import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError, } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadPredioDto, CreatePredioDto, UpdatePredioDto } from '@/api.types';

export async function GetPredios(skip: number, take: number) {
  return api
    .get(Endpoints.PREDIO, { params: { skip: skip, take: take } })
    .then((response) => {
      return GetApiReturn<ReadPredioDto>(response.data as Array<ReadPredioDto>);
    })
    .catch((error) => {
      ValidateAxiosError<ReadPredioDto>(error, 'Falha ao listar Prédios.');
      return GetApiReturnError<ReadPredioDto>();
    });
}

export async function GetPredio(id: number) {
  return api
    .get<ReadPredioDto>(Endpoints.PREDIO + '/' + id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<ReadPredioDto>(error, 'Falha ao bucar o Prédio.' + id);
    });
}

export async function SetPredio(predio: CreatePredioDto | UpdatePredioDto) {
  if (predio.id !== null && predio.id != undefined && predio.id > 0) {

    return api
      .put(Endpoints.PREDIO + '/' + predio.id, predio as UpdatePredioDto)
      .then(() => {
        return 'Prédio atualizado.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(
          error,
          'Falha ao atualizar o Prédio.',
        );
      });
  } else {
    return api
      .post(Endpoints.PREDIO, predio as CreatePredioDto)
      .then(() => {
        return 'Prédio cadastrado.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(
          error,
          'Falha ao cadastrar o Prédio.',
        );
      });
  }
}

export async function DeletePredio(id: number) {
  return api
    .delete(Endpoints.PREDIO + '/' + id)
    .then(() => {
      return 'Prédio removido.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao remover Prédio.');
    });
}